module.exports = __webpack_public_path__ + "static/media/signup.594757c1.jpg";